import { useState } from 'react';
import { SelectChipsInput } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import {
  SelectedDateType,
  FiltersType,
  selectedRangeType,
} from '~myAccount/pages/Wallet/types';
import { Icon, SelectBoxInput } from '@aqarmap/aqarmap-ui';
import DateFilterDropdown from '~myAccount/pages/Wallet/DateFilterDropdown';
import useFilterByDate from '~myAccount/pages/Wallet/hooks/useFilterByDate';
import { useBreakpoint } from '~/hooks';
import Modal from '~/components/Modal';
import { useAppDispatch } from '~/redux/hooks';
import { closeModal, openModal } from '~/redux/features/uiState/uiStateSlice';
import { TransactionTypeEnum } from '~/types/walletTypes';
import '~myAccount/pages/Wallet/styles.css';

export default function TransactionsFilter({
  onChange,
}: {
  onChange: (values: FiltersType) => void;
}) {
  const chipLabelClassName = 'text-body_2 text-gray__dark_2';
  const chipClassName = 'py-x rounded-[12px] px-2x';
  const { dateRangeValues } = useFilterByDate();
  const dispatch = useAppDispatch();
  const { t } = useTranslation('app');
  const [selectedDate, setSelectedDate] = useState<SelectedDateType>({
    value: 'allTime',
    range: dateRangeValues['allTime'],
  });
  const [open, setOpen] = useState<boolean>(true);
  const { mobileScreen } = useBreakpoint();

  const handleDateChange = (range: selectedRangeType) => {
    if (mobileScreen) {
      dispatch(closeModal('dateRangeFilterModal'));
    } else {
      setOpen(false);
    }
    onChange({ ...range });
  };

  return (
    <div className="flex  justify-between w-full">
      <SelectChipsInput
        handleChange={(_e, selected) => {
          onChange({
            types: selected !== 'all' ? [selected] : [],
          });
        }}
        className="!w-auto chips-select"
        list={[
          {
            field: {
              name: 'all',
              value: 'all',
              checked: true,
            },
            label: {
              text: t('all'),
              className: chipLabelClassName,
            },
            className: chipClassName,
          },
          {
            field: {
              name: 'top-up',
              value: TransactionTypeEnum.TOP_UP,
            },
            label: {
              text: t('topUps'),
              className: chipLabelClassName,
            },
            className: chipClassName,
          },
          {
            field: {
              name: 'payments',
              value: TransactionTypeEnum.SPEND,
            },
            label: {
              text: t('payments'),
              className: chipLabelClassName,
            },
            className: chipClassName,
          },
        ]}
      />
      {mobileScreen ? (
        <>
          <button
            className="flex justify-center items-center h-[40px] w-[40px] bg-gray_light_1 rounded-full"
            onClick={() => dispatch(openModal('dateRangeFilterModal'))}
          >
            <Icon name="calender" size="24px" className="text-gray__dark_2" />
          </button>
          <Modal
            modalKey="dateRangeFilterModal"
            title={t('filterResultsByDate')}
            bodyClassName="pb-3x"
          >
            <DateFilterDropdown
              onSubmit={handleDateChange}
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
            />
          </Modal>
        </>
      ) : (
        <div className="min-w-[287px] w-auto">
          <SelectBoxInput
            field={{
              name: 'date',
              placeholder: 'select date',
              value: t(selectedDate.value),
            }}
            startIcon={
              <Icon name="calender" size="24px" className="text-gray__dark_2" />
            }
            open={open}
            setOpen={setOpen}
          >
            <DateFilterDropdown
              onSubmit={handleDateChange}
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
            />
          </SelectBoxInput>
        </div>
      )}
    </div>
  );
}
